import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Button } from '@/components/ui/button';
    import { Minus } from 'lucide-vue-next';
    import {
        AlertDialog,
        AlertDialogAction,
        AlertDialogCancel,
        AlertDialogContent,
        AlertDialogDescription,
        AlertDialogFooter,
        AlertDialogHeader,
        AlertDialogTitle,
        AlertDialogTrigger,
    } from '@/components/ui/alert-dialog';
    import { router } from '@inertiajs/vue3';
    import { toast } from 'vue-sonner';
    import { useI18n } from 'vue-i18n';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DisconnectBank',
  props: {
    companyId: {}
  },
  setup(__props: any) {

    const props = __props;

    const { t } = useI18n();

    const deactivateBankConnection = () => {
        router.post(
            route('v2.bank.deactivate-connection', props.companyId),
            {},
            {
                preserveScroll: true,
                onSuccess: () => {
                    toast.success(t('viia.deactivate.deactivate_bank_connection_success'));
                },
                onError: (error) => {
                    toast.error(t('viia.deactivate.deactive_bank_connection_failed'));
                },
            },
        );
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AlertDialog), null, {
    default: _withCtx(() => [
      _createVNode(_unref(AlertDialogTrigger), { "as-child": "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Button), {
            variant: "ghost_destructive",
            size: "xs",
            width: "narrow"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('viia.deactivate.deactivate_bank_connection')) + " ", 1),
              _createVNode(_unref(Minus), { class: "text-destructive" })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(AlertDialogContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(AlertDialogHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(AlertDialogTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('viia.deactivate.js.deactive_bank_connection_title')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(AlertDialogDescription), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('viia.deactivate.js.deactive_bank_connection_confirm')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(AlertDialogFooter), null, {
            default: _withCtx(() => [
              _createVNode(_unref(AlertDialogCancel), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('viia.deactivate.js.no')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(AlertDialogAction), { onClick: deactivateBankConnection }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('viia.deactivate.js.yes')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})